export default __webpack_public_path__ + "static/media/code-img2.e959e89d.JPG";